<div class="dashboard-container">
  <div id="dashboard">
    @if(isCardAccess){
    <div *ngIf="!isImportInProgress && (!hasEverUsedDragDrop || isScanInProgress)" class="bulk-upload-container"
      id="cc-drag-drop-strip">
      <div class="upload-cloud_wrapper">
        <img class="upload-cloud" src="assets/svg-icons/icons/upload-cloud.svg" alt="">
        <div class="bulk-upload_text">
          <h6 *ngIf="!isScanInProgress" class="upload-title">{{'drag_drop_cc_statement' | translate}}</h6>
          <h6 *ngIf="isScanInProgress" class="upload-title">{{'drag_drop_cc_scanning_in_progress' | translate}}</h6>
          <p *ngIf="!isScanInProgress" class="upload-sub_title">{{'drop_cc_statement_anywhere' | translate}} |
            {{'accepted_formats' | translate}}:
            <span class="text-italic-primary">.pdf, .csv, .xls, .xlsx</span>
          </p>
          <p *ngIf="isScanInProgress" class="upload-sub_title">
            <span class="text-secondary fw-600">{{'cc_scanning_in_progress' | translate}}</span>
          </p>
          <div class="warning-info-container --borderless py-1 px-2 rounded-3 w-fit-content">
            <p class="paragraph-10">
              <span class="fw-600">Tip: </span>{{'cc_import_tip' | translate}}
            </p>
          </div>
        </div>
      </div>
      <img *ngIf="!isScanInProgress" class="drop-animation" src="../../assets/images/ds-images/drag-drop-animation.gif"
        alt="">
      <button *ngIf="isScanInProgress" class="btn btn-primary btn-primary--md" style="white-space:nowrap;flex-shrink:0;"
        (click)="fnReopenScanModal()">
        {{'cc_view_scan_status' | translate}}
      </button>
    </div>

    <div *ngIf="isImportInProgress" class="bulk-upload-container" id="cc-import-progress-strip">
      <div class="upload-cloud_wrapper" style="gap: 16px;">
        <img class="upload-cloud" [src]="ICONS.CLOCK" alt="">
        <div class="bulk-upload_text">
          <h6 class="upload-title">{{'cc_import_in_progress' | translate}}</h6>
          <p class="upload-sub_title" style="margin:0;">
            {{'label_total' | translate}}: {{importingTransactionCount}}
            &nbsp;|&nbsp;
            <span class="text-success">{{'label_imported' | translate}}: {{importedCount}}</span>
            &nbsp;|&nbsp;
            <span class="text-warning">{{'remaining' | translate}}: {{remainingCount}}</span>
          </p>
        </div>
      </div>
      <button class="btn btn-primary btn-primary--md" style="white-space:nowrap;flex-shrink:0;"
        (click)="fnReopenImportModal()">
        {{'cc_view_import_status' | translate}}
      </button>
    </div>
    }
    <div class="action-item-parent">
      @if((isDataLoadComplete && fmAsApproverSummary && fmAsApproverSummary.length > 0)
      || (isFinanceApprovalAccess && financeApprovalPendingCount)
      || (isPayAccess && financePayPendingCount)
      || (isCardAccess && approvalSummary.dismissedExpensesCount > 0)
      || (isAdvancedMileageAccess && isMileagePurchased && approvalSummary.vehicleApprovalCount > 0)
      || (isDutyofCareAccess && approvalSummary.pendingDutyofCareApprovalCount > 0)
      || (isVendorAccess && approvalSummary.pendingKYCApprovalCount > 0)){<div class="action-item-container"
        id="itemsForApproval">
        @if(isDataLoadComplete && fmAsApproverSummary && fmAsApproverSummary.length > 0){<ds-dashboard-action-btn
          [id]="'action-approval-btn'" [actionItem]="'items_for_approval' | translate"
          [counter]="this.approvalSummary.totalCountOfItemForApproval"
          [iconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (click)="showOrphanspop(true)">
        </ds-dashboard-action-btn>}
        @if(isFinanceApprovalAccess && financeApprovalPendingCount){<ds-dashboard-action-btn
          [id]="'action-finance-approvals-btn'" [actionItem]="'items_for_finance_approval' | translate"
          [counter]="financeApprovalPendingCount" [iconSrc]="'assets/svg-icons/icons/chevron-right.svg'"
          (click)="changeUrl('financeapprover/faexpenses/1')">
        </ds-dashboard-action-btn>}
        @if(isPayAccess && financePayPendingCount){<ds-dashboard-action-btn [id]="'action-payments-btn'"
          [actionItem]="'items_for_payment' | translate" [counter]="financePayPendingCount"
          [iconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (click)="changeUrl('pay/payexpenses/1')">
        </ds-dashboard-action-btn>}
        @if(isCardAccess && this.approvalSummary.dismissedExpensesCount > 0){<ds-dashboard-action-btn
          [id]="'action-credit-card-btn'" [actionItem]="'dismissed_credit_card_items' | translate"
          [counter]="this.approvalSummary.dismissedExpensesCount" [iconSrc]="'assets/svg-icons/icons/chevron-right.svg'"
          (click)="fnShowCardDashboard()">
        </ds-dashboard-action-btn>}
        @if(isAdvancedMileageAccess && isMileagePurchased && this.approvalSummary.vehicleApprovalCount >
        0){<ds-dashboard-action-btn [id]="'action-vehicles-btn'" [actionItem]="'vehicles_for_approval' | translate"
          [counter]="this.approvalSummary.vehicleApprovalCount" [iconSrc]="'assets/svg-icons/icons/chevron-right.svg'"
          (click)="goProducts()">
        </ds-dashboard-action-btn>}
        @if(isDutyofCareAccess && this.approvalSummary.pendingDutyofCareApprovalCount > 0){<ds-dashboard-action-btn
          [id]="'action-dutyofcare-btn'" [actionItem]="'items_for_duty_of_care_approval' | translate: param"
          [counter]="this.approvalSummary.pendingDutyofCareApprovalCount"
          [iconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (click)="changeUrl('dutyofcare/dutyofapproval')">
        </ds-dashboard-action-btn>}
        @if(isVendorAccess && this.approvalSummary.pendingKYCApprovalCount > 0){<ds-dashboard-action-btn
          [id]="'action-kyc-btn'" [actionItem]="'items_for_kyc_approval' | translate: param"
          [counter]="this.approvalSummary.pendingKYCApprovalCount"
          [iconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (click)="changeUrl('vendorSetup/approveDoc')">
        </ds-dashboard-action-btn>}
      </div>}
    </div>
    <div class="ds-dashboard-card-container" id="overview-manageExpenses" (click)="fnShowBookDemoPanel()">
      <ds-dashboard-card [id]="'incomplete-claims-card'" [iconSrc]="'assets/svg-icons/icons/clock.svg'"
        [isCardType]="'--border-warning'" [iconClass]="'is-card-icon-warning'" [isButtonLabel]="isLiabilityReportAccess"
        [anchorIconSrc]="'assets/svg-icons/icons/arrow-up-right.svg'"
        [cardTitle]="'incomplete_claims' | translate: param" (anchorClick)="claims.isBasicFunctionPurchased ? showLiabilityReport() : fnShowBookDemoPanel()"
        [activeItems1]="this.incompleteExpenses.claimants" [activeItems2]=" this.incompleteExpenses.count">
      </ds-dashboard-card>
      @if(isTwoStepPurchased){<ds-dashboard-card [id]="'pending-with-approver-two-step-card'"
        [iconSrc]="'assets/svg-icons/icons/user-clock.svg'" [isCardType]="'--border-warning'"
        [iconClass]="'is-card-icon-warning'" [isButtonLabel]="false"
        [anchorIconSrc]="'assets/svg-icons/icons/arrow-up-right.svg'"
        [cardTitle]="'pending_with_approver' | translate: param"
        (anchorClick)="claims.isBasicFunctionPurchased ? fnGetDashboardPresetData(expenseStatusEnum.PendingWithApprover,this.pendingExpensesWithApprover.count) : fnShowBookDemoPanel()"
        [activeItems1]="this.pendingExpensesWithApprover.claimants"
        [activeItems2]=" this.pendingExpensesWithApprover.count">
      </ds-dashboard-card>}
      @if(!isTwoStepPurchased){<ds-dashboard-card [id]="'pending-with-approver-non-two-step-card'"
        [ngbPopover]="popContent" triggers="mouseenter:mouseleave" placement="right"
        [iconSrc]="'assets/svg-icons/icons/user-clock.svg'" [isCardType]="'--border-warning'"
        [iconClass]="'is-card-icon-warning'" [isButtonLabel]="false"
        [anchorIconSrc]="'assets/svg-icons/icons/arrow-up-right.svg'"
        [cardTitle]="'pending_with_approver' | translate: param" (anchorClick)="claims.isBasicFunctionPurchased ? showTwoStepPopup() : fnShowBookDemoPanel()"
        [activeItems1]="this.pendingExpensesWithApprover.claimants"
        [activeItems2]=" this.pendingExpensesWithApprover.count">
      </ds-dashboard-card>}
      <ng-template #popContent>
        <div>{{'after_approval' | translate:param}}</div>
      </ng-template>
      <ds-dashboard-card [id]="'pending-finance-approval-card'"
        [ngClass]="{'opacity-50 cursor-pointer': !this.isTwoStepPurchased || !this.isTwoStepApprovalTurnOn, disabled: !isFinanceApprovalAccess }"
        (click)="claims.isBasicFunctionPurchased ? showTwoStepPopup() : fnShowBookDemoPanel()" [iconSrc]="'assets/svg-icons/icons/user-recall.svg'"
        [isCardType]="'--border-warning'" [iconClass]="'is-card-icon-warning'"
        [buttonClass]="'btn btn-danger-tertiary btn-danger-tertiary--sm'" [isButtonLabel]="false"
        [anchorIconSrc]="'assets/svg-icons/icons/arrow-up-right.svg'" [anchorClass]="''"
        [isAnchorDisabled]="!this.isTwoStepPurchased || !this.isTwoStepApprovalTurnOn"
        [cardTitle]="'pending_finance_approval' | translate: param"
        (anchorClick)="claims.isBasicFunctionPurchased ? fnGetDashboardPresetData(expenseStatusEnum.Approved, this.pendingExpensewithFA.count) : fnShowBookDemoPanel()"
        [activeItems1]="this.pendingExpensewithFA.claimants" [activeItems2]=" this.pendingExpensewithFA.count">
      </ds-dashboard-card>
      <ds-dashboard-card [id]="'pending-passed-for-payment-card'"
        [ngClass]="{'opacity-50 cursor-pointer': !this.isTwoStepPurchased || !this.isTwoStepApprovalTurnOn, disabled: !isPayAccess }"
        (click)="claims.isBasicFunctionPurchased ? showTwoStepPopup() : fnShowBookDemoPanel()" [iconSrc]="'assets/svg-icons/icons/cc-clock.svg'" [isCardType]="'--border-warning'"
        [iconClass]="'is-card-icon-warning'"
        [buttonClass]="isPayStepEnabled ? ('btn btn-danger-tertiary btn-danger-tertiary--sm') : ('btn btn-success-tertiary btn-success-tertiary--sm') "
        [isButtonLabel]="this.actionableRecordForDashboard && this.isTwoStepPurchased && this.isTwoStepApprovalTurnOn"
        [buttonLabel]="isPayStepEnabled ? ('Disable' |  translate) : ('Enable' |  translate)"
        (buttonClick)="claims.isBasicFunctionPurchased ? fnShowSetupSkipPayStepPanel() : fnShowBookDemoPanel()" [anchorIconSrc]="'assets/svg-icons/icons/arrow-up-right.svg'"
        [isAnchorDisabled]="(!isTwoStepPurchased || !isTwoStepApprovalTurnOn)" [anchorClass]="''"
        [cardTitle]="'pending_passed_for_payment' | translate: param"
        (anchorClick)="claims.isBasicFunctionPurchased ? fnGetDashboardPresetData( expenseStatusEnum.ApprovedForPayment, this.pendingPassedForPayment.count) : fnShowBookDemoPanel()"
        [activeItems1]="this.pendingPassedForPayment.claimants" [activeItems2]=" this.pendingPassedForPayment.count">
      </ds-dashboard-card>
      <ds-dashboard-card [id]="'passed-for-payment-export-card'"
        [ngClass]="{ disabled: this.passedForPayment.count == 0 || !isAccExportAccess }" (click)="claims.isBasicFunctionPurchased ? fnExportClick() : fnShowBookDemoPanel()"
        [iconSrc]="'assets/svg-icons/icons/shield-solid.svg'" [isCardType]="'--border-success'"
        [iconClass]="'is-card-icon-success'" [buttonClass]="'btn btn-success btn-primary-tertiary--sm'"
        [buttonLabel]="'label_export' |  translate: param"
        [isButtonLabel]="this.passedForPayment.count > 0 && this.isBuildReportAccess" [anchorClass]="''"
        [cardTitle]="'passed_for_payment' | translate: param" [activeItems1]="this.passedForPayment.claimants"
        [activeItems2]=" this.passedForPayment.count">
      </ds-dashboard-card>
    </div>
    <div class="ds-dashboard-chart-container" id="overview-expenseGraph">
      <ds-dashboard-chart [title]="'manageCat_emp' | translate: param" [buttonLabel]="'View All'"
        [buttonClass]="'btn btn-primary-tertiary btn-primary-tertiary--sm'" [chartId]="'canvasbar'"
        [isShowContent]="false" [footerItems]="[
            { text: 'label_pending'| translate: param, indicatorClass: 'warning-indicator' },
            { text: 'label_notinvited' | translate: param, indicatorClass: 'error-indicator' },
            { text: 'label_active' | translate: param, indicatorClass: 'success-indicator' }
        ]">
      </ds-dashboard-chart>
      <ds-dashboard-chart [title]="'mileage_analysis' | translate: param" [isShowContent]="!isCanvasbar1Display"
        [buttonLabel]="'View All'" [buttonClass]="'btn btn-primary-tertiary btn-primary-tertiary--sm'"
        [chartId]="'canvasbar1'" [isShowImg]="isCanvasbar1Display"
        [iconSrc]="'assets/svg-icons/dashboard/dummy-Mileage-chart.svg'" [footerItems]="[
            { text: 'manual_mileage'| translate: param, indicatorClass: 'accent-indicator' },
            { text: 'mileage_google' | translate: param, indicatorClass: 'primary-indicator' },
            { text: 'mileage_gps' | translate: param, indicatorClass: 'success-indicator' }
        ]">
      </ds-dashboard-chart>
      <ds-dashboard-chart [title]="'approval_rejection_trend' | translate: param" [isShowContent]="!isCanvasbar2Display"
        [chartId]="'canvas'" [isShowImg]="isCanvasbar2Display"
        [iconSrc]="'assets/svg-icons/dashboard/dummy-Approval-chart.svg'"
        [altText]="'vehicle_summary' | translate: param" [footerItems]="[
            { text: 'approved_expenses'| translate: param, indicatorClass: 'line-success-indicator' },
            { text: 'rejected_expenses' | translate: param, indicatorClass: 'line-rejected-indicator' }
          ]">
      </ds-dashboard-chart>
    </div>
    <div class="ds-sub-dashboard-card-container" id="miscOverview">
      @if(isAdvancedMileageAccess){<ds-sub-dashboard-card [id]="'vehicle-summary-subcard'"
        [iconSrc]="'assets/svg-icons/icons/car.svg'" [text]="'vehicle_summary' | translate: param"
        [chevronIconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (cardClick)="claims.isBasicFunctionPurchased ? showMileageMarketingPopup(1) : fnShowBookDemoPanel()">
      </ds-sub-dashboard-card>}
      @if(isCardAccess){<ds-sub-dashboard-card [id]="'credit-card-dashboard-subcard'"
        [iconSrc]="'assets/svg-icons/icons/credit-card.svg'" [text]="'credit_card_dashboard' | translate: param"
        [chevronIconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (cardClick)="claims.isBasicFunctionPurchased ? showCreditCardMarketingPopup() : fnShowBookDemoPanel()">
      </ds-sub-dashboard-card>}
      @if(isAdvancedMileageAccess){<ds-sub-dashboard-card [id]="'mileage-analysis-subcard'"
        [iconSrc]="'assets/svg-icons/icons/map.svg'" [text]="'mileage_analysis' | translate: param"
        [chevronIconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (cardClick)="claims.isBasicFunctionPurchased ? showMileageMarketingPopup(2) : fnShowBookDemoPanel()">
      </ds-sub-dashboard-card>}
      @if(isManageCategoryAccess){<ds-sub-dashboard-card [id]="'top-spenders-subcard'"
        [iconSrc]="'assets/svg-icons/icons/dollars.svg'" [text]="'top_10_spenders_categories' | translate: param"
        [chevronIconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (cardClick)="claims.isBasicFunctionPurchased ? showManageCategoryMarketingPopup() : fnShowBookDemoPanel()">
      </ds-sub-dashboard-card>}
      @if(isLiabilityReportAccess){<ds-sub-dashboard-card [id]="'liability-report-subcard'"
        [iconSrc]="'assets/svg-icons/icons/bar-chart-alt.svg'" [text]="'liabilityReport_header' | translate: param"
        [chevronIconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (cardClick)="claims.isBasicFunctionPurchased ? showLiabilityReport() : fnShowBookDemoPanel()">
      </ds-sub-dashboard-card>}
      @if(isAuditTrailAccess){<ds-sub-dashboard-card [id]="'audit-trail-subcard'"
        [iconSrc]="'assets/svg-icons/icons/trending-up.svg'" [text]="'audit_trial' | translate: param"
        [chevronIconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (cardClick)="claims.isBasicFunctionPurchased ? showAuditTrail() : fnShowBookDemoPanel()">
      </ds-sub-dashboard-card>}
      @if(isNRFCAccess){<ds-sub-dashboard-card [id]="'home-subcard-nr-fuel'"
        [iconSrc]="'assets/svg-icons/icons/bill.svg'" [text]="'nr_dashboard' | translate: param"
        [chevronIconSrc]="'assets/svg-icons/icons/chevron-right.svg'"
        (cardClick)="claims.isBasicFunctionPurchased ? fnDisplayMarketingPopUp(this.functionPackageEnum.NonReimbursableFuel) : fnShowBookDemoPanel()">
      </ds-sub-dashboard-card>}
      @if(isNRFCAccess){<ds-sub-dashboard-card [id]="'fuelcard-subcard'"
        [iconSrc]="'assets/svg-icons/icons/fuel-line.svg'" [text]="'fc_report' | translate: param"
        [chevronIconSrc]="'assets/svg-icons/icons/chevron-right.svg'"
        (cardClick)="claims.isBasicFunctionPurchased ? fnDisplayMarketingPopUp(this.functionPackageEnum.FuelCard) : fnShowBookDemoPanel()">
      </ds-sub-dashboard-card>}
      <ds-sub-dashboard-card [id]="'policy-dashboard-subcard'" [iconSrc]="'assets/svg-icons/icons/policy-check.svg'"
        [text]="'expense_policy_dashboard' | translate: param"
        [chevronIconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (cardClick)="claims.isBasicFunctionPurchased ? fnpolicyDashboardNavigation() : fnShowBookDemoPanel()">
      </ds-sub-dashboard-card>
      @if(isAdvancesAccess){<ds-sub-dashboard-card [id]="'carbon-footprint-subcard'"
        [iconSrc]="'assets/svg-icons/icons/carbon-footprint.svg'" [text]="'carbon_footprint' | translate: param"
        [chevronIconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (cardClick)="claims.isBasicFunctionPurchased ? showCarbonFootprint() : fnShowBookDemoPanel()">
      </ds-sub-dashboard-card>}
      @if(isAdvancesAccess){<ds-sub-dashboard-card [id]="'advances-subcard'"
        [iconSrc]="'assets/svg-icons/icons/wallet-money.svg'" [text]="'advances_dashboard' | translate: param"
        [chevronIconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (cardClick)="claims.isBasicFunctionPurchased ? showAdvances() : fnShowBookDemoPanel()">
      </ds-sub-dashboard-card>}
      @if(isVendorAccess && IsAPAutomationAllowed){<ds-sub-dashboard-card [id]="'ap-automation-subcard'"
        [iconSrc]="'assets/svg-icons/icons/pie-chart.svg'" [text]="'label_vendor_dashborad' | translate: param"
        [chevronIconSrc]="'assets/svg-icons/icons/chevron-right.svg'" (cardClick)="claims.isBasicFunctionPurchased ? showAPAutomation() : fnShowBookDemoPanel()">
      </ds-sub-dashboard-card>}
      @if(isLeaveManagementAccess && IsLeaveManagementAllowed && (!(isVendorAccess && IsAPAutomationAllowed) ||
      (isVendorAccess && IsAPAutomationAllowed))){
      <ds-sub-dashboard-card [id]="'leave-management-subcard'" [iconSrc]="'assets/svg-icons/icons/calendar.svg'"
        [text]="'leave_management' | translate: param" [chevronIconSrc]="'assets/svg-icons/icons/chevron-right.svg'"
        (cardClick)="claims.isBasicFunctionPurchased ? showLeaveManagementDashboard() : fnShowBookDemoPanel()">
      </ds-sub-dashboard-card>}
    </div>
    <div class="row">

      @if(showFounderMessageModal){<founder-message [isVisible]="showFounderMessageModal"
        [loginUserName]="'Dear ' + loggedInUserDisplayName+','"
        [modalDescription]="('message_from_founder_1' | translate) + '<br><br>' + ('message_from_founder_2' | translate) + '<br><br>' + ('message_from_founder_3' | translate) + '<br><br>' + ('message_from_founder_4' | translate) + '<br><br>' + ('message_from_founder_5' | translate)"
        (closeEvent)="onCloseFoundersNote()"></founder-message>}

      @if(showEssentialPackStartup){ <essential-pack-startup (continueEvent)="fnContinueEssentialPackStartup($event)">
      </essential-pack-startup>}


      @if(isFeedbackPanelActive){<feedback-panel [type]="feedbackPanelType" (closePanel)="onCloseFeedbackPanel()">
      </feedback-panel>}

      <!-- will use new Panel common component  -->
      @if(showPendingEmployeeWithGradePopup){<div class="overLayDiv active"></div>}
      @if(showPendingEmployeeWithGradePopup){<div id="rightSideBar" style="display: block">
        <div class="rightSidePanel d-flex flex-column">
          <header class="panel-header">
            <div class="viewDemo title-and-video">
              <h2>{{ "information" | translate: param }}</h2>
            </div>
          </header>
          <div>
            <div class="block mt-2">
              <h6 class="info-text">
                <span>
                  {{ noOfEmployeeDoNotHaveGrade }}
                  {{ "employee_do_not_have_grade" | translate: param }}
                </span>
              </h6>
            </div>
            <div class="block mt-2">
              <h6 class="info-text">
                <i class="fas fa-info-circle"></i>
                <span>{{ "please_assign_rate_to_grade" | translate: param }}</span>
              </h6>
            </div>
          </div>
          <footer class="mt-auto py-1 d-flex justify-content-center align-items-center gap-2 height-60px">
            <button type="button" class="btn eod-btn-outline-warning" (click)="closePendingEmployeeWithGrade()">
              {{ "change_password_cancel" | translate: param }}
            </button>
            <button type="button" class="btn eod-btn-primary" (click)="navigateToAssignGradesToClaimant()">
              {{ "setup" | translate: param }}
            </button>
          </footer>
        </div>
      </div>}


      @if(apAutomationPopup){<marketing-popup [data]="marketingPopupPanel" (closePanel)="closeAPAutomation()">
      </marketing-popup>}

      @if(liabilityReportPopup){<marketing-popup [data]="liabilityReportPopupModel"
        (closePanel)="closeLiabilityReport()">
      </marketing-popup>}

      @if(cfpPopup){<marketing-popup [data]="cfpMarketingPopupModel" (closePanel)="closeMarketingPopup()">
      </marketing-popup>}

      @if(advancesPopup){<marketing-popup [data]="advancesMarketingPopupModel" (closePanel)="closeMarketingPopup()">
      </marketing-popup>}

      @if(auditTrailPopup){<marketing-popup [data]="liabilityReportPopupModel" (closePanel)="closeAuditTrail()">
      </marketing-popup>}

      @if(leaveManagementPopup){<marketing-popup [data]="liabilityReportPopupModel"
        (closePanel)="closeLeaveManagement()">
      </marketing-popup>}

      @if(twoStepApprovalPopup){<marketing-popup [data]="liabilityReportPopupModel"
        (closePanel)="closeMarketingPopup()">
      </marketing-popup>}

      @if(this.showGooglePackagePurchaseReminder){<app-googlePackagePurchaseReminderPanel>
      </app-googlePackagePurchaseReminderPanel>}

      @if(isAlertDisplay){<app-alert-panel [data]="alertPanelModel" isConfirmDisplay="false"
        (callbackEvent)="alertPanelReceiver($event)">
      </app-alert-panel>}
      <deputy-reminder-panel [hidden]="!showPendingDeputiesPopup" [panelData]="deputyReminderModel"
        (closePanelEvent)="closePendingDeputiesPopup($event)">
      </deputy-reminder-panel>

      <audit-trail-reminder-panel [hidden]="!showAuditTrailReminderPanel" [panelData]="auditTrailReminderModel"
        (closePanelEvent)="closeAuditTrailReminderPanel($event)">
      </audit-trail-reminder-panel>

      <org-setup-reminder-panel [hidden]="!showOrgSetupReminderPanel" [panelData]="orgSetupReminderModel"
        (closePanelEvent)="closeOrgSetupReminderPanel($event)">
      </org-setup-reminder-panel>


      @if(this.nrfcConfigModel.isMarketingPopUpDisplay){<marketing-popup
        [data]="this.nrfcConfigModel.secondaryFMPopupModel" (closePanel)="closeSecondaryFMPopup()">
      </marketing-popup>}
      @if(creditCardPopup){<marketing-popup [data]="creditCardMarketingPopupModel" (closePanel)="closeMarketingPopup()">
      </marketing-popup>}
      @if(categoryMarketingPopup){<marketing-popup [data]="manageCategoryMarketingPopupModel"
        (closePanel)="closeMarketingPopup()">
      </marketing-popup>}
      @if(mileageMarketingPopup){<marketing-popup [data]="mileageMarketingPopupModel"
        (closePanel)="closeMarketingPopup()">
      </marketing-popup>}
    </div>
  </div>

  <!-- will use new Panel common component  -->
  @if(costCentresWithoutApproverCount){<div class="overLayDiv"></div>}
  <div id="rightSideBar">
    @if(costCentresWithoutApproverCount){<div class="rightSidePanel d-flex flex-column">
      <header class="panel-header">
        <div class="viewDemo title-and-video">
          <h2>{{ 'information' | translate }}</h2>
        </div>
      </header>
      <div class="block mt-2">
        <h6 class="info-text">
          <span [innerHTML]="costCentresWithoutApproversMessage"></span>
        </h6>
      </div>
      <div class="block">
        <h6 class="info-text">
          <i class="fas fa-exclamation-circle eod-text-danger"></i>
          <span>{{ 'note_assign_approvers_cc_urgent' | translate: param }}</span>
        </h6>
      </div>
      <footer class="mt-auto py-1 d-flex justify-content-center align-items-center gap-2 height-60px">
        <button type="button" class="btn eod-btn-outline-warning" (click)="closeCostCentreAlertPanel()">
          {{ 'cancel_text' | translate }}
        </button>
        <button type="button" class="btn eod-btn-primary" (click)="goToAssignCostCentreApprovers()">
          {{ 'label_setup' | translate : param }}
        </button>
      </footer>
    </div>}
  </div>

  @if(showOrphanspopUp){<app-approval-items (closePanel)="closeOrphansPopup()"
    [fmAsApproverSummary]="fmAsApproverSummary" [fmAsApproverData]="fmAsApproverData">
  </app-approval-items>}

  @if(showDutyofCarePopup){<app-alert-panel [data]="showDutyofCarePopupModel"
    (callbackEvent)="fnDutyofCarePopupReceiver($event)">
  </app-alert-panel>}

  @if(showPresetExportPanel){<preset-export [selectedPresetExportStatus]="selectedPresetExportStatus"
    (closePanel)="closePresetExportPanel()" [isCounterApproverPurchased]="isCounterApproverPurchased">
  </preset-export>}

  @if(showStripPaymentFailedPanel){<stripe-invoice-failed-details-panel
    (closePanelEvent)="fnCloseStripPaymentFailedPanel($event)">
  </stripe-invoice-failed-details-panel>}

  @if(showRecommendationPanel){<app-recommendation [currentRecomm]="currentRecommModel"
    (closePanel)="closeRecommendationPanel()" [orgRecomm]="orgRecomm">
  </app-recommendation>}
  @if(showSetupSkipPayStepPanel){<setup-pay-step-panel [data]="setupSetupSkipPayStepPanelInputmodel"
    (closePanelEvent)="fnCloseSetupSkipPayStepPanel($event)" (submitEvent)="fnSubmitSetupSkipPayStepPanel($event)">
  </setup-pay-step-panel>}

  @if(showAssignClaimantToGradePopup){<grade-assign-employee [isFromExternal]="true"
    (closePanelEvent)="closeAssignClaimanttogradePopup()">
  </grade-assign-employee>}

  @if(showExpiredLocationAlertPanel){
  <app-alert-panel [data]="officeLocationExpiredAlertModel" (callbackEvent)="fnCloseExpiredLocationAlertPanel($event)">
  </app-alert-panel>
  }

  @if(showBookDemoPanel){
 <book-demo-panel (closePanelEvent)="fnCloseBookDemoPanel()"></book-demo-panel>
  }
 
<!-- <ds-modal [modalInput]="modalConfig">
    <div class="modal-content-wrapper" modal-body>
      <div class="info-grident-body">
        <h5 class="m-0 text-on-primary">info-acent-grident-bg-2</h5>
        <div class="alert-tag-borderd">
          <p>Day 14 - 1 day left</p>
        </div>
      </div>
      <p>Transition to Read-Only to retain permanent access to historical data. Pricing based on your subscription at termination.</p>
      <div class="error-info-container --borderless">
        <ul class="ds-info-text --icon-alert-circle --alert">
          <li>If we do not hear from you, your subscription will be <b>automatically cancelled after 7 days</b></li>
        </ul>
      </div>
    </div>
    <div modal-footer>
        <ds-button [buttonInput]="cancelButtonConfig">
        </ds-button>
        <ds-button [buttonInput]="yesButtonConfig">
        </ds-button>
    </div>
</ds-modal> -->